export const FormFieldRow = ({ children }: React.PropsWithChildren) => {
  return <div className={'grid grid-cols-1 @xl:grid-cols-2 @5xl:grid-cols-4 gap-4'}>{children}</div>
}
